import { IdpRequestError } from 'models/errors'
import store from '../store/store'
import { getRequestError } from './errorService'

/* INTERCEPTORS */
const { fetch: originalFetch } = window

window.fetch = async (...args) => {
  const [resource, config] = args

  const path = resource as string

  /* Request Interceptor */

  //end of request interceptor

  // Set headers + config
  if (config?.method === 'POST' || config?.method === 'PUT' || config?.method === 'PATCH') {
    config.headers = { ...config?.headers, 'Content-Type': 'application/json' }
  }

  // Make Request
  const response = await originalFetch(path, config)

  /* Response Interceptor */
  const redirectUrl = response.headers.get('X-Redirect-URL')

  if (redirectUrl) {
    window.location.href = redirectUrl
  }
  //end of response interceptor

  // Return response
  return response
}

export const apiGet = async (endpoint: string, urlParams?: object) => {
  const params = urlParams
    ? Object.values(urlParams)
        .map((param) => '&' + new URLSearchParams(param))
        .join('&')
    : ''

  const ens = store.getState().ens
  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}${params}`, {
    method: 'GET'
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })

  if (response.status >= 200 && response.status < 300) {
    const result = response.status === 204 ? null : await response?.json()
    return { status: response.status, body: result }
  } else {
    let result
    try {
      result = response ? await response.json() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(
      response.status,
      response.statusText,
      result?.message,
      null,
      response.headers.has('X-Redirect-URL')
    )
  }
}

export const apiPostLogout = async (endpoint: string) => {
  const ens = store.getState().ens
  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}`, {
    method: 'POST'
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })

  if (response.status >= 200 && response.status < 300) {
    const result = response.status === 204 ? null : await response?.text()
    return { status: response.status, body: result }
  } else {
    let result
    try {
      result = response ? await response.text() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(response.status, response.statusText)
  }
}

export const apiGetErrorTesting = async (endpoint: string, urlParams?: object) => {
  const params = urlParams
    ? Object.values(urlParams)
        .map((param) => '&' + new URLSearchParams(param))
        .join('&')
    : ''

  const ens = store.getState().ens
  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}${params}`, {
    method: 'GET'
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })

  if (response.status >= 300 && response.status < 300) {
    const result = response.status === 204 ? null : await response?.json()
    return { status: response.status, body: result }
  } else {
    throw getRequestError(500, response.statusText, '')
  }
}

export const apiGetText = async (endpoint: string, urlParams?: object) => {
  const params = urlParams
    ? Object.values(urlParams)
        .map((param) => '&' + new URLSearchParams(param))
        .join('&')
    : ''

  const ens = store.getState().ens
  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}${params}`, {
    method: 'GET'
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })

  if (response.status >= 200 && response.status < 300) {
    const result = response.status === 204 ? null : await response?.text()
    return { status: response.status, body: result }
  } else {
    let result
    try {
      result = response ? await response.json() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(
      response.status,
      response.statusText,
      result?.message,
      null,
      response.headers.has('X-Redirect-URL')
    )
  }
}

export const apiPut = async (endpoint: string, myBody: object, type: 'json' | 'text' = 'json') => {
  const ens = store.getState().ens

  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}`, {
    method: 'PUT',
    body: JSON.stringify(myBody)
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })
  if (response.status >= 200 && response.status < 300) {
    if (type === 'text') {
      const url = await response.text()
      return { status: response.status, body: url }
    }
    return { status: response.status }
  } else {
    let result
    try {
      result = response ? await response.json() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(
      response.status,
      response.statusText,
      result?.message,
      result?.field,
      response.headers.has('X-Redirect-URL')
    )
  }
}

export const apiPatch = async (endpoint: string, myBody: object) => {
  const ens = store.getState().ens

  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}`, {
    method: 'PATCH',
    body: JSON.stringify(myBody)
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })
  if (response.status >= 200 && response.status < 300) {
    return { status: response.status }
  } else {
    let result
    try {
      result = response ? await response.json() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(
      response.status,
      response.statusText,
      result?.message,
      null,
      response.headers.has('X-Redirect-URL')
    )
  }
}

export const apiDelete = async (endpoint: string) => {
  const ens = store.getState().ens

  const response = await fetch(`${endpoint}?ens=${ens.ensActiu}`, {
    method: 'DELETE'
  }).catch((err: Error) => {
    throw new IdpRequestError(err.message)
  })
  if (response.status >= 200 && response.status < 300) {
    return { status: response.status }
  } else {
    let result
    try {
      result = response ? await response.json() : null
    } catch (error) {
      result = null
    }
    throw getRequestError(
      response.status,
      response.statusText,
      result?.message,
      null,
      response.headers.has('X-Redirect-URL')
    )
  }
}
